import { render, staticRenderFns } from "./BullProposal.vue?vue&type=template&id=51874c2e&scoped=true&"
import script from "./BullProposal.vue?vue&type=script&lang=js&"
export * from "./BullProposal.vue?vue&type=script&lang=js&"
import style0 from "./BullProposal.vue?vue&type=style&index=0&id=51874c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51874c2e",
  null
  
)

export default component.exports